import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import ClientInsights from "./pages/ClientInsights";
import IndustryInsights from "../src/components/IndustryInsights";
import "./App.css";
import HomePage from "./pages/HomePage";
import customTheme from "./customTheme";
import { ThemeProvider } from "@mui/material/styles";
import { ClientProvider } from "./context/ClientContext";
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { GlobalModalProvider } from "./context/GlobalModalContext";
import { ChatbotProvider } from "./context/ChatbotContext";
import { LanguageProvider } from "./context/LanguageContext";
import Login from "./pages/Login";
import { LoadingProvider } from "./context/LoadingContext";
import GlobalLoading from "./components/GlobalLoading";
import Notification from "./pages/Notification";
import { AuthContextProvider } from "./context/AuthContextProvider";
import { QueryTypeProvider } from "./context/QueryTypeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { UploadProvider } from "./context/UploadContext";
import CorporateAIRM from "./pages/CorporateAIRM";
import { CenterPanelProvider } from "./context/CenterPanelContext";

function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <AuthContextProvider>
      <UploadProvider>
        <LoadingProvider>
          <CenterPanelProvider>
            <ChatbotProvider>
          <GlobalModalProvider>
            <LanguageProvider>
              <QueryTypeProvider>
                <ChatbotProvider>
                  <ClientProvider>
                    
                    <Router>
                      <Routes>
                        {/* Main Layout with Persistent Header */}
                        <Route
                          element={
                            <ProtectedRoute>
                              <MainLayout />
                            </ProtectedRoute>
                          }
                        >
                          <Route
                            path="/landing"
                            element={
                              <ProtectedRoute>
                                <HomePage />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/clientInsights"
                            element={
                              <ProtectedRoute>
                                <ClientInsights />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/agentic"
                            element={
                              <ProtectedRoute>
                                <CorporateAIRM />
                              </ProtectedRoute>
                            }
                          />
                          <Route
                            path="/notifications"
                            element={
                              <ProtectedRoute>
                                <Notification />
                              </ProtectedRoute>
                            }
                          />
                        </Route>
                        <Route path="/" element={<Login />} />
                      </Routes>
                    </Router>
                    
                  </ClientProvider>
                </ChatbotProvider>
              </QueryTypeProvider>
            </LanguageProvider>
            <GlobalLoading />
          </GlobalModalProvider>
          </ChatbotProvider>
          </CenterPanelProvider>
               </LoadingProvider>
        </UploadProvider>
      </AuthContextProvider>
    </ThemeProvider>
  );
}

export default App;
